import { render, staticRenderFns } from "./BottomLine.vue?vue&type=template&id=643f8489&scoped=true&"
import script from "./BottomLine.vue?vue&type=script&name=wave-title&lang=js&"
export * from "./BottomLine.vue?vue&type=script&name=wave-title&lang=js&"
import style0 from "./BottomLine.vue?vue&type=style&index=0&id=643f8489&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f8489",
  null
  
)

export default component.exports